import './sortHeader.scss'
import clsx from 'clsx'
import { SortingUpIcon, SortingDownIcon, SortingIcon } from '@/shared/assets'

type SortDirection = 'asc' | 'desc'

interface SortConfig<T> {
    key: keyof T
    direction: SortDirection
}

interface SortHeaderProps<T> {
    title: React.ReactNode
    field: keyof T
    sortConfig: SortConfig<T> | null
    onSort: (field: keyof T) => void
    className?: string
    classNameSpan?: string
}

export const SortHeader = <T,>({
    title,
    field,
    sortConfig,
    onSort,
    className,
    classNameSpan,
}: SortHeaderProps<T>) => {
    const isActive = sortConfig?.key === field

    return (
        <div
            className={clsx('sort-header', className)}
            onClick={() => onSort(field)}
        >
            <span className={clsx('sort-header__title', classNameSpan)}>{title}</span>
            <div className="sort-header__icons">
                {!isActive && (
                    <img
                        src={SortingIcon}
                        className="sort-header__icon"
                        alt="Sort"
                    />
                )}
                {isActive && sortConfig?.direction === 'asc' && (
                    <img
                        src={SortingUpIcon}
                        className="sort-header__icon sort-header__icon--active"
                        alt="Ascending"
                    />
                )}
                {isActive && sortConfig?.direction === 'desc' && (
                    <img
                        src={SortingDownIcon}
                        className="sort-header__icon sort-header__icon--active"
                        alt="Descending"
                    />
                )}
            </div>
        </div>
    )
}
